import React from 'react';

import QuotaArcorSellers  from 'components/Tvendo/Sale/QuotaBPartner/Arcor/QuotaSellers/List.js';

export default function () {
  return <QuotaArcorSellers  />;
}